import { rootApi } from '../rootApi';

export const materialCatalogApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getMaterialCatalogDetail: builder.query({
            query: (body) => ({
                url: 'v1/MaterialCatalog/GetDetail',
                method: 'POST',
                body,
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount ?? 0,
                    };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['MaterialCatalog'],
        }),
        getMaterialCatalogMovement: builder.query({
            query: (body) => ({
                url: 'v1/MaterialCatalog/GetMovement',
                method: 'POST',
                body,
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount ?? 0,
                    };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['MaterialCatalog'],
        }),
        getMaterialCatalogOtherCompany: builder.query({
            query: (body) => ({
                url: 'v1/MaterialCatalog/GetOtherCompany',
                method: 'POST',
                body,
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount ?? 0,
                    };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['MaterialCatalog'],
        }),
        exportMaterialCatalogDetailToExcel: builder.query({
            keepUnusedDataFor: 0,
            query: (params) => ({
                url: 'v1/materialcatalog/detailexporttoexcel',
                method: 'POST',
                body: {
                    kunnr: params.kunnr ?? null,
                    partCode: params.partCode ?? null,
                    languageId: params.languageId ?? 1
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType };
                }
                throw new Error(response?.errorMessage || 'Export failed');
            }
        }),

        exportMaterialCatalogMovementToExcel: builder.query({
            keepUnusedDataFor: 0,
            query: (params) => ({
                url: 'v1/materialcatalog/movementexporttoexcel',
                method: 'POST',
                body: {
                    dealerCode: params.dealerCode ?? null,
                    partCode: params.partCode ?? null
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType };
                }
                throw new Error(response?.errorMessage || 'Export failed');
            }
        }),

        exportMaterialCatOtherCompanyToExcel: builder.query({
            keepUnusedDataFor: 0,
            query: (params) => ({
                url: 'v1/materialcatalog/othercompanyexporttoexcel',
                method: 'POST',
                body: {
                    dealerCode: params.dealerCode ?? null,
                    partCode: params.partCode ?? null,
                    languageId: params.languageId ?? 1
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType };
                }
                throw new Error(response?.errorMessage || 'Export failed');
            }
        })
    }),
    
});

export const {
useLazyGetMaterialCatalogDetailQuery,      
    useLazyGetMaterialCatalogMovementQuery,    
    useLazyGetMaterialCatalogOtherCompanyQuery,
    useLazyExportMaterialCatalogDetailToExcelQuery,
    useLazyExportMaterialCatalogMovementToExcelQuery,
    useLazyExportMaterialCatOtherCompanyToExcelQuery

} = materialCatalogApi;